import React, { useState } from "react";
import Toggle from "./Toggle";

const SasPanels = ({ data, handleUpdate }) => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const handleChange = (checked, property) => {
    handleUpdate({ ...data, [property]: checked });
  };

  const properties = [
    {
      id: "overview",
      checked: data?.overview ?? true,
      title: "Overview",
      property: "overview",
    },
    {
      id: "ranks_prices",
      checked: data?.ranks_and_prices ?? true,
      title: "Ranks and Prices",
      property: "ranks_and_prices",
    },
    {
      id: "alert",
      checked: data?.alerts ?? true,
      title: "Alerts",
      property: "alerts",
    },
    {
      id: "profit_calculator",
      checked: data?.profit_calculator ?? true,
      title: "Profit Calculator",
      property: "profit_calculator",
    },
    {
      id: "chart",
      checked: data?.charts ?? true,
      title: "Charts",
      property: "charts",
    },
    {
      id: "variation",
      checked: data?.variations ?? true,
      title: "Variations",
      property: "variations",
    },
    {
      id: "dimensions",
      checked: data?.dimensions ?? true,
      title: "Dimensions",
      property: "dimensions",
    },
    {
      id: "seller_central",
      checked: data?.seller_central ?? true,
      title: "Seller Central",
      property: "seller_central",
    },
    {
      id: "offers",
      checked: data?.offers ?? true,
      title: "Offers",
      property: "offers",
    },
    {
      id: "lookup_details",
      checked: data?.lookup_details ?? true,
      title: "Lookup Details",
      property: "lookup_details",
    },
    {
      id: "roi",
      checked: data?.roi ?? true,
      title: "R.O.I",
      property: "roi",
    },
    {
      id: "buybox_analysis",
      checked: data?.buybox_analysis ?? true,
      title: "Buy Box Analysis",
      property: "buybox_analysis",
    },
  ];

  return (
    <div
      className="flex flex-col w-full border-primary bg-primary-bg p-4 mt-4 border border-border/100 rounded-2xl"
    >
      <div
        className="flex cursor-pointer items-center mb-2"
        onClick={toggleAccordion}
      >
        <div
          className="mr-1 text-primary font-bold"
          style={{ fontSize: "16px" }}
        >
          ScanProfit Panels
        </div>
      </div>

      {isOpen && (
        <div>
          {properties.map(({ id, title, property, checked }) => (
            <div
              key={id}
              className="flex text-white justify-between bg-secondary-dark p-4 rounded-lg align-center mb-2"
              style={{ fontSize: "13px" }}
            >
              <div
                className="w-full flex items-center"
                style={{ textAlign: "left" }}
              >
                <div className="ml-2 text-sm">{title}</div>
              </div>
              <div className="w-1/4 flex justify-end items-center">
                <Toggle
                  checked={checked}
                  handleChange={(checked) => handleChange(checked, property)}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SasPanels;
